import styled from 'styled-components'
import {
  LargeLink as LargeLinkStyles,
  Link as LinkStyles,
} from '@chegg-wt/core/theme/sunkist/link'
import { BodyLargeBold, BodyLarge } from '@chegg-wt/core/theme/sunkist/typography'

export const LargeLink = styled.a`
  ${LargeLinkStyles};
`

export const EmptyList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${BodyLarge};
  padding: 50px;
`

export const Button = styled.a`
  ${LinkStyles};
`

export const Text = styled.p`
  ${BodyLargeBold};
`
